import { takeLatest, call } from 'redux-saga/effects'
import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import I18n from 'i18n'

import * as fromActions from 'store/actions/monitoring.actions'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import {
  sendEmailAPI,
  SelectedCollaboratorsSendEmailAPI,
} from 'api/administration/monitoring/SendEmail'

async function sendEmail(
  selectedCollaborators: SelectedCollaboratorsSendEmailAPI,
  courseId: number,
  subject: string,
  content: string,
  filterData?: IFilterData,
  search?: string
) {
  return sendEmailAPI({
    selectedCollaborators: {
      add: selectedCollaborators.add,
      discard: selectedCollaborators.discard,
      all: selectedCollaborators.all,
    },
    courseId,
    subject,
    content,
    filterData,
    search,
  })
}

function* minitoringSendEmailEffectSaga(action: any) {
  try {
    const {
      selectedCollaborators,
      courseId,
      subject,
      content,
      filterData,
      searchText,
    } = action.payload
    yield call(
      sendEmail,
      selectedCollaborators,
      courseId,
      subject,
      content,
      filterData,
      searchText
    )
    SuccessToast(I18n.t('administration.monitor.sendEmail.toast.success'))
  } catch (error) {
    console.log('error: ', error)
    ErrorToast(I18n.t('administration.monitor.sendEmail.toast.error'))
  }
}

export function* monitoringSendEmailWatcherSaga() {
  yield takeLatest(fromActions.SEND_EMAIL, minitoringSendEmailEffectSaga)
}
